<template>
  <div class="wrapper">
    <div class="search">
      <div class="search-ipt">
        <div class="search-input">
          <input type="text" placeholder="搜索收款方、付款方名称" v-model="searchParams.name">
        </div>
        <div class="search-icon" @click="onRefresh">
          搜索
        </div>
      </div>
      <div class="filter-option">
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="searchOptions.invoiceStatus"
            :options="statusOptions"
            @change="changeStatus"
          />
          <van-dropdown-item
            v-model="searchParams.invoiceType"
            :options="invoiceTypeOptions"
            @change="changeType"
          />
          <van-dropdown-item
            v-model="searchOptions.applyDate"
            :options="applyDateOptions"
            @change="changeApplyDate"
          />
        </van-dropdown-menu>
        <p class="filter-btn" @click="openAllCard" v-if="!this.cardOpened">批量报账</p>
      </div>
    </div>
    <div class="pull-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-swipe-cell
            v-for="(invoice, index) in invoiceList"
            :key="index" :ref="'swipecell'+invoice.id"
            :name="invoice.id"
            :disabled="true"
            :before-close="beforeClose"
            :class="[!cardOpened ? 'swiper-cell-custom-wrp': ''].join(' ')"
          >
            <slot slot="left" name="left">
              <div class="select-wrp" v-if="invoice.commitFlag === 1"><i class="iconfont select-font-disabled">&#xe69c;</i></div>
              <div class="select-wrp" v-else-if="!invoice.select"><i class="iconfont select-font" v-tap="{methods: selectInvoice, params:{invoice}}">&#xe69c;</i></div>
              <div class="select-wrp" v-else-if="invoice.select"><i class="iconfont select-font-active" v-tap="{methods: cancelInvoice, params:{invoice}}">&#xe69d;</i></div>
            </slot>
            <IncomeCard
              type="income"
              :invoice="invoice"
              :incomeParams="{remark: invoice.remark}"
              @incomeJump="gotoPage(invoice)"
            />
          </van-swipe-cell>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="select-footer" v-if="this.cardOpened">
      <div class="wrp">
        <div class="select-wrp" v-if="selectCount === 0 || selectCount !== getCouldSelectedCount(invoiceList)"><i class="iconfont select-font" v-tap="{methods: selectAllInvoice, params:{}}">&#xe69c;</i></div>
        <div class="select-wrp" v-else-if="selectCount === getCouldSelectedCount(invoiceList)"><i class="iconfont select-font-active" v-tap="{methods: cancelAllInvoice, params:{}}">&#xe69d;</i></div>
        <div class="content">全选</div>
        <div class="content">已选择<span>{{selectCount}}张</span>发票</div>
      </div>
      <div class="btn-wrp">
        <van-button
          class="btn"
          round
          @click="openAllCard"
        >
          取消
        </van-button>
        <van-button
          class="btn"
          round
          @click="commitSelect"
        >
          批量报账
        </van-button>
      </div>

    </div>
    <div class="camera-footer">
      <span class="iconfont">
        &#xe6cc;
      </span>
      <input @change="cameraChange" ref="camera" type="file" accept="image/*" />
    </div>
  </div>
</template>

<script>
import { officialAccountRequest } from '@services'
import IncomeCard from '@components/IncomeCard'
import {
  DropdownMenu,
  DropdownItem,
  List,
  PullRefresh,
  SwipeCell,
  Button,
  Notify
} from 'vant'
import Observer from '@utils/observer'
import { convertBase64UrlToBlob, cutImageBase64 } from '@utils/basicUtil'
import moment from 'moment'
export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [SwipeCell.name]: SwipeCell,
    [Notify.name]: Notify,
    [Button.name]: Button,
    IncomeCard
  },
  props: {},
  data () {
    return {
      statusOptions: [
        { text: '全部状态', value: undefined },
        { text: '验真失败', value: 0 },
        { text: '验真成功', value: 1 },
        { text: '提交报账', value: 2 }
      ],
      invoiceTypeOptions: [
        { text: '全部类型', value: undefined },
        { text: '专票', value: '01' },
        { text: '普票', value: '04' },
        { text: '电子普票', value: '10' },
        { text: '电子专票', value: '08' },
        { text: '卷票', value: '11' },
        { text: '定额发票', value: '200' },
        { text: '火车票', value: '201' },
        { text: '飞机票', value: '202' },
        { text: '出租车票', value: '207' }
      ],
      applyDateOptions: [
        { text: '开票日期', value: undefined }
      ],
      searchParams: {
        size: 25,
        current: 1,
        desc: 'createTime',
        name: '',
        commitFlag: '',
        isItTrue: '',
        startTime: '',
        endTime: ''
      },
      searchOptions: {
        invoiceStatus: undefined,
        applyDate: undefined
      },
      invoiceList: [],
      refreshing: false,
      loading: false,
      finished: true,
      cardOpened: false,
      selectCount: 0
    }
  },
  computed: {
    camera: (vm) => {
      return vm.$refs.camera
    }
  },
  watch: {},
  created () {},
  mounted () {
    let { searchParams, searchOptions } = this.$store.state.invoice.invoiceHomeApplySearch
    this.searchParams = searchParams
    this.searchOptions = searchOptions
    this.initApplyDateOptions()
    this.getList()
    Observer.setFunction({ type: 'changeCompany', fn: this.companyChangeRefresh })
  },
  activated () {},
  updated () {},
  methods: {
    getList () {
      this.getInvoiceList()
    },
    companyChangeRefresh () {
      if (window.location.pathname === '/invoice/income-home') {
        this.onRefresh()
      }
    },
    initApplyDateOptions () {
      let applyDateOptions = [
        { text: '开票日期', value: undefined }
      ]
      var data = new Date()
      // var year = data.getFullYear()
      data.setMonth(data.getMonth() + 1, 1) // 获取到当前月份,设置月份
      for (var i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        var m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        let value = data.getFullYear() + '-' + (m)
        applyDateOptions.push({ text: value, value: value })
      }
      this.applyDateOptions = applyDateOptions
    },
    async getInvoiceList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const data = await officialAccountRequest.weChat.getInvoiceList(this.searchParams)
      if (data.success) {
        if (data.result.records) {
          this.invoiceList = [...this.invoiceList, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
        Notify({ type: 'danger', message: data.message })
      }

      this.loading = false
    },
    async commitSelect () {
      let vatIdList = []
      let nonVatIdList = []
      this.invoiceList.forEach(v => {
        if (v.select) {
          if (this.getInvoiceType(v.invoiceType)) { // 增票
            vatIdList.push(v.id)
          } else { // 非增票
            nonVatIdList.push(v.id)
          }
        }
      })
      const data = await officialAccountRequest.weChat.batchCommit({ vatIdList, nonVatIdList })
      if (data.success) {
        Notify({ type: 'success', message: '提交成功' })
        this.$router.go(0)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    onRefresh () {
      this.finished = false
      this.searchParams.current = 1
      this.cardOpened = false
      this.selectCount = 0
      this.invoiceList = []
      this.getInvoiceList()
    },
    onLoad () {
      this.searchParams.current++
      this.getInvoiceList()
    },
    changeStatus (value) {
      if (value === 0) {
        this.searchParams.isItTrue = value
        this.searchParams.commitFlag = ''
      } else if (value === 1) {
        this.searchParams.isItTrue = value
        this.searchParams.commitFlag = 0
      } else if (value === 2) {
        this.searchParams.commitFlag = 1
        this.searchParams.isItTrue = ''
      } else {
        this.searchParams.isItTrue = ''
        this.searchParams.commitFlag = ''
      }
      this.onRefresh()
    },
    changeType (value) {
      this.searchParams.changeType = value
      this.onRefresh()
    },
    changeApplyDate (value) {
      // this.searchParams.changeApplyDate = value
      if (value) {
        this.searchParams.startTime = moment(value).startOf('month').format('YYYY-MM-DD HH:mm:ss')
        this.searchParams.endTime = moment(value).endOf('month').format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.searchParams.startTime = ''
        this.searchParams.endTime = ''
      }
      this.onRefresh()
    },
    selectInvoice (data) {
      let list = [...this.invoiceList]
      let selectCount = 0
      list.forEach(v => {
        if (v.id === data.params.invoice.id) {
          v.select = true
        }
        if (v.select) {
          selectCount += 1
        }
      })
      this.invoiceList = list
      this.selectCount = selectCount
    },
    cancelInvoice (data) {
      let list = [...this.invoiceList]
      let selectCount = 0
      list.forEach(v => {
        if (v.id === data.params.invoice.id) {
          v.select = false
        }
        if (v.select) {
          selectCount += 1
        }
      })
      this.invoiceList = list
      this.selectCount = selectCount
    },
    selectAllInvoice (data) {
      this.invoiceList.forEach(v => {
        if (!v.commitFlag) {
          v.select = true
        }
      })
      this.selectCount = this.getCouldSelectedCount(this.invoiceList)
    },
    getCouldSelectedCount (list) {
      return list.filter(v => v.commitFlag !== 1).length
    },
    cancelAllInvoice (data) {
      this.invoiceList.forEach(v => {
        v.select = false
      })
      this.selectCount = 0
    },
    openAllCard () {
      if (this.cardOpened) {
        this.cardOpened = false
        Object.keys(this.$refs).forEach(key => {
          if (key.includes('swipecell')) {
            this.$refs[key][0] && this.$refs[key][0].close('left')
          }
        })
      } else {
        this.cardOpened = true
        Object.keys(this.$refs).forEach(key => {
          if (key.includes('swipecell')) {
            this.$refs[key][0] && this.$refs[key][0].open('left')
          }
        })
      }
    },
    beforeClose ({ position, instance }) {
      switch (position) {
        case 'left':
          break
      }
    },
    getInvoiceType (invoiceType) { // 获取发票的类型 1增值税票 0非增值税票
      let type = 0
      switch (invoiceType) {
        case '01':
          type = 1
          break
        case '04':
          type = 1
          break
        case '10':
          type = 1
          break
        case '08':
          type = 1
          break
        case '11':
          type = 1
          break
        case '200':
          type = 0
          break
        case '201':
          type = 0
          break
        case '202':
          type = 0
          break
        case '207':
          type = 0
          break
        default:
          break
      }
      return type
    },
    gotoPage (params) {
      let type = this.getInvoiceType(params.invoiceType)
      this.$router.push(`/invoice/income/invoice?id=${params.id}&type=${type}`)
    },
    cameraChange () {
      let file = this.camera.files[0]
      cutImageBase64(file, null, 1000, 0.8, (data) => {
        this.cutSuccess({ base64: data, file: convertBase64UrlToBlob(data) })
      })
    },
    cutSuccess (data) {
      this.$store.commit('invoice/changeImage', data)
      this.$router.push('/newInvoice/collect')
    }
  },
  beforeDestroy () {
    let params = {
      searchParams: {
        ...this.searchParams,
        current: 1
      },
      searchOptions: this.searchOptions
    }
    this.$store.commit('invoice/saveIncomeHomeSearch', params)
  }
}
</script>
<style lang="less" scoped src="./style.less"/>
